export default "__VITE_ASSET__ef386c5f__"